var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 3H7.8c-1.68 0-2.52 0-3.162.315A2.949 2.949 0 0 0 3.327 4.58C3 5.198 3 6.008 3 7.629v5.496c0 1.348 0 2.022.228 2.553a2.949 2.949 0 0 0 1.624 1.566c.551.22 1.25.22 2.648.22.489 0 .733 0 .96.052.302.069.583.204.821.396.18.144.326.332.619.71l1.46 1.877c.217.279.326.418.459.468a.517.517 0 0 0 .362 0c.133-.05.242-.19.459-.468l1.46-1.878c.293-.377.44-.565.619-.709a2.03 2.03 0 0 1 .822-.396c.226-.052.47-.052.959-.052 1.398 0 2.097 0 2.648-.22a2.948 2.948 0 0 0 1.624-1.566c.228-.531.228-1.205.228-2.553V8.379",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.808 11.076a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 0 1.5h-.008a.75.75 0 0 1-.75-.75zM11.218 11.076a.75.75 0 0 1 .75-.75h.008a.75.75 0 1 1 0 1.5h-.008a.75.75 0 0 1-.75-.75zM7.628 11.076a.75.75 0 0 1 .75-.75h.009a.75.75 0 0 1 0 1.5h-.009a.75.75 0 0 1-.75-.75z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.012 2.25C20.203 2.25 21 3.368 21 4.41c0 2.111-3.315 3.84-3.375 3.84-.06 0-3.375-1.729-3.375-3.84 0-1.042.799-2.16 1.988-2.16a1.79 1.79 0 0 1 1.387.641 1.79 1.79 0 0 1 1.387-.641z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandPageIcon);
export default __webpack_public_path__ + "static/media/brand_page_icon.7a44a5a2105e6807caaf159b329c77b8.svg";
export { ForwardRef as ReactComponent };